"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hmacSHA512 = void 0;
var hmac_1 = require("./noble/hmac.js");
var sha512_1 = require("./noble/sha512.js");
/**
 * here because we need it in `@harmoniclabs/bip32_ed25519`
 *
 * and in particular, because it is a dependency of `pbkdf2` (which could also be calculated using native webcrypto)
 */
function hmacSHA512(key, data) {
    return new Uint8Array((0, hmac_1.hmac)(sha512_1.sha512, key, data));
}
exports.hmacSHA512 = hmacSHA512;
